import React from 'react';

/**
 * The title row every zone card opens with: a heading on the left and, optionally,
 * one action on the right ("7 open →", "All requests →"). Kept in one place so the
 * cards can't drift in size or weight.
 *
 * @param {object} props
 * @param {string} props.title
 * @param {React.ReactNode} [props.action]  Rendered right-aligned; omitted when absent.
 * @param {React.ReactNode} [props.badge]   Rendered beside the title (a count pill).
 * @param {string} [props.className]
 * @param {string} [props.actionClassName]  Extra classes for the action's wrapper (e.g. full width on a phone).
 */
export default function CardHeader({ title, action = null, badge = null, className = '', actionClassName = '' }) {
  return (
    <div className={`flex items-center justify-between gap-3 ${className}`}>
      <div className="flex min-w-0 items-center gap-2">
        <h3 className="truncate text-lg font-semibold text-gray-900 dark:text-gray-100">{title}</h3>
        {badge}
      </div>
      {action ? <div className={`shrink-0 ${actionClassName}`.trim()}>{action}</div> : null}
    </div>
  );
}
